<template>
  <div class="grid-view">
    <div class="main-content finance-code-mapping">
      <cargo-left-right-resize
        :left-style="{flex:'none','max-width':'220px'}"
        :right-style="{'overflow': 'hidden'}"
        style="min-height:100%"
      >
        <template slot="left">
          <div style="min-width: 180px;width:100%;height:100%;padding:0px;">
            <cargo-ag-grid
              :show-side-bar="false"
              :grid-options="leftGrid.gridOptions"
              :row-data="leftGrid.rowData"
              :column-defs="leftGrid.columnDefs"
              style="width:100%;height:100%;min-height: 500px;padding-left: 0px;"
              @gridReady="params=>{leftGrid.gridApi=params.api;leftGrid.gridApi.setFocusedCell(0, 'chineseName');}"
            />
          </div>
        </template>
        <template slot="right">
          <div class="section operations" style="flex:1;overflow:hidden;display:flex;flex-direction:column;height: 100%">
            <div class="filters" style="padding-left: 5px;">
              <span v-if="isEdit">
                <el-button type="primary" @click="saveHandler">{{ $t('common.btn.save') }}</el-button>
                <el-button type="primary" @click="cancelHandler">{{ $t('common.btn.cancel') }}</el-button>
                <el-button v-if="(isSales || isPartner || isDept) && isJDYXC && ($checkPermission(['role_FinanceInterfaceConfigure_GetKingdeId']) || $store.getters.isAdmin)" type="primary" @click="getKingdeId">{{ $t('CargoMsg.Cargo_GetKingdeId') }}</el-button>
              </span>
              <span v-else>
                <!-- 供应商、客户 -->
                <el-select
                  v-if="hasMapping"
                  v-model="codeType"
                >
                  <el-option v-for="item in mappings" :key="item.value" :value="item.value" :label="item.name" />
                </el-select>
                <!-- 应收、应付 -->
                <span v-show="sortRP" style="margin-right: 10px;">{{ $t('CargoMsg.Cargo_PaymentReceiveType') }}</span>
                <el-select
                  v-if="sortRP"
                  v-model="rpType"
                  style="margin-right: 10px;"
                >
                  <el-option :value="0" :label="$t('CargoMsg.Cargo_Receivable')" />
                  <el-option :value="1" :label="$t('CargoMsg.Cargo_Dues')" />
                </el-select>
                <el-input v-if="txtFilterVisible" v-model="txtFilter" style="width: 200px;margin: 0 5px 0 5px;" />
                <el-checkbox v-if="cbNewMappingVisible" v-model="cbNewMapping" style="margin: 0 10px 0 5px;">{{ $t('CargoMsg.Cargo_DisplayUnCodedRecordsOnly') }}</el-checkbox>
                <el-button v-if="$checkPermission(['button_EncodeMapping_query'])" type="primary" @click="queryCodeMapping">{{ $t('common.btn.query') }}</el-button>
                <el-button v-if="$checkPermission(['button_EncodeMapping_add'])" type="primary" @click="addHandler">{{ $t('common.btn.new') }}</el-button>
                <el-button v-if="$checkPermission(['button_EncodeMapping_edit'])" type="primary" :disabled="!cellSelected" @click="editHandler">{{ $t('common.btn.edit') }}</el-button>
                <el-button v-if="$checkPermission(['button_EncodeMapping_delete'])" type="danger" :disabled="!cellSelected" @click="removeHandler">{{ $t('common.btn.delete') }}</el-button>
                <el-button v-if="hasMapping" type="primary" @click="downloadExcelHandler">{{ $t('CargoMsg.Cargo_TemplateDownload') }}</el-button>
                <el-upload
                  v-if="hasMapping"
                  :action="URL.finance.financeCodeMapping.saveExcelFile"
                  :headers="{sessionId: $store.getters.userInfo.sessionId}"
                  :data="{accountSetUuid:accountSet.uuid}"
                  :show-file-list="false"
                  accept=".xls, .xlsx"
                  :on-success="onImportSucceeded"
                  :on-error="handleError"
                  :before-upload="handleBeforeUpload"
                  style="display: inline-block;margin: 0 5px"
                >
                  <el-button type="primary">{{ $t('CargoMsg.Cargo_ImportExcel') }}</el-button>
                </el-upload>
                <el-button v-if="fit" type="primary" @click="syncFinanceCode">{{ $t('CargoMsg.Cargo_SynchronousCodingPartners') }}</el-button>
                <el-button v-if="isInvoiceTitle" type="primary" @click="downloadExcelTitleHandler">{{ $t('CargoMsg.Cargo_TemplateDownload') }}</el-button>
                <el-upload
                  v-if="isInvoiceTitle"
                  :action="URL.finance.financeCodeMapping.saveExcelFile2Title"
                  :headers="{sessionId: $store.getters.userInfo.sessionId}"
                  :data="{accountSetUuid:accountSet.uuid}"
                  :show-file-list="false"
                  accept=".xls, .xlsx"
                  :on-success="onImportSucceeded"
                  :on-error="handleError"
                  :before-upload="handleBeforeUpload"
                  style="display: inline-block;margin: 0 5px"
                >
                  <el-button type="primary">{{ $t('CargoMsg.Cargo_ImportExcel') }}</el-button>
                </el-upload>
                <el-button v-if="showUpdateCustomerInfo && ($checkPermission(['role_FinanceInterfaceConfigure_UpdateCustomerInfo']) || $store.getters.isAdmin)" type="primary" @click="updateCustomerInfo">{{ $t('CargoMsg.Cargo_UpdateCustomerInfo') }}</el-button>
                <el-button v-if="isInvoiceTitle" type="primary" @click="syncFinanceCode">{{ $t('CargoMsg.Cargo_SyncCustomerData') }}</el-button>
              </span>
            </div>
            <div class="section grid-wrapper">
              <cargo-ag-grid
                :show-side-bar="false"
                :grid-params.sync="gridParams"
                :grid-options="gridOptions"
                :column-defs="columnDefs"
                :row-data="rowData"
                style="width:100%;height:100%;min-height: 500px;"
              />
            </div>
            <div class="pagination-wrapper">
              <cargo-pagination
                :total="pageConditions.total"
                :page.sync="pageConditions.pageNum"
                :limit.sync="pageConditions.pageSize"
                @pagination="queryCodeMapping"
              />
            </div>
          </div>
        </template>
      </cargo-left-right-resize>
      <mapping-code-selector
        :visible.sync="selectorDialog.visible"
        :account-set="accountSet"
        :code-mapping-type="selectorDialog.codeMappingType"
        :code-type="selectorDialog.codeType"
        :exists-map="selectorDialog.existsMap"
        :exists-partner-map="selectorDialog.existsPartnerMap"
        @enter="enterHandler"
      />
      <cashflow-item-dialog
        :visible.sync="cashflowItemDialog.visible"
        :account-set="accountSet"
        @enter="enterCashflowItemHandler"
      />
    </div>
    <!-- 同步客商编码弹窗 -->
    <el-dialog
      :visible.sync="syncCodePartnerDialog.visible"
      :title="$t('CargoMsg.Cargo_SynchronousCodingPartners')"
      width="500px"
      :close-on-click-modal="false"
      custom-class="sync-code-partner-dialog"
    >
      <div v-show="syncCodePartnerDialog.step===1" class="step1" style="display: flex;flex-direction: column;">
        <el-steps :active="1" align-center>
          <el-step :title="$t('FinanceManage.SelectNewEncodingType')" />
          <el-step :title="$t('FinanceManage.SelectMatchingPartnerFieldType')" icon="icon-solid-circle-origin" />
        </el-steps>
        <div style="margin-top: 15px">
          <span style="font-size: 16px;margin: 15px 0 0 40px;">{{ $t('FinanceManage.NewEncodingType') }}</span>
          <el-checkbox v-model="syncCodePartnerDialog.customerCodeCheck" style="margin-left: 10px">{{ $t('FinanceManage.CustomerCode') }}</el-checkbox>
          <el-checkbox v-model="syncCodePartnerDialog.providerCodeCheck" style="margin-left: 35px">{{ $t('FinanceManage.SupplierCode') }}</el-checkbox>
        </div>
      </div>
      <div v-show="syncCodePartnerDialog.step===2" class="step2" style="display: flex;flex-direction: column;">
        <el-steps :active="1" align-center finish-status="success">
          <el-step :title="$t('FinanceManage.SelectNewEncodingType')" />
          <el-step :title="$t('FinanceManage.SelectMatchingPartnerFieldType')" />
        </el-steps>
        <div style="margin-top: 15px">
          <span style="font-size: 16px;margin: 15px 0 0 40px;">{{ $t('FinanceManage.MatchPartnerFieldTypes') }}</span>
          <el-select
            v-model="syncCodePartnerDialog.field"
            style="margin-left: 10px; width: 211px;"
          >
            <el-option v-for="(item, index) in partnerFields" v-if="(isInvoiceTitle && item.value !== 'CHINESE_NAME') || isPartner" :key="index" :value="item.value" :label="item.label" />
          </el-select>
        </div>
        <div v-if="isInvoiceTitle" style="margin-top: 15px">
          <span style="font-size: 16px;margin: 15px 0 0 72px;">{{ $t('CargoMsg.Cargo_InvoiceHeader') + $t('CargoMsg.Cargo_CreatedDate') + (isZh ? '：' : ':') }}</span>
          <el-select v-model="syncCodePartnerDialog.titleDateOperation" style="margin-left: 10px; width: 60px;">
            <el-option v-for="(item, index) in titleDateOperations" :key="index" :value="item.value" :label="item.label" />
          </el-select>
          <cargo-date-time-picker
            v-model="syncCodePartnerDialog.titleDate"
            no="begin"
            value-format="yyyy-MM-dd"
            type="date"
            clearable
            style="width: 140px;margin-left: 10px;"
          />
        </div>
        <div v-else style="margin-top: 15px">
          <span style="font-size: 16px;margin: 15px 0 0 40px;">{{ $t('CargoMsg.Cargo_Match') + $t('CargoMsg.Cargo_Parter') + $t('CargoMsg.Cargo_CreatedDate') + (isZh ? '：' : ':') }}</span>
          <cargo-date-time-picker
            v-model="syncCodePartnerDialog.dateCreatedStart"
            no="begin"
            value-format="yyyy-MM-dd"
            type="date"
            clearable
            style="width: 100px;margin-left: 10px;"
            :picker-options="{
              disabledDate: time => {
                const endDate = syncCodePartnerDialog.dateCreatedEnd ? new Date(syncCodePartnerDialog.dateCreatedEnd + ' 23:59:59') : null;
                if (endDate) {
                  // 基础限制：限制开始日期不能晚于结束日期
                  if (time.getTime() > endDate.getTime()) {
                    return true
                  }
                }
                return false
              }
            }"
          />
          <span style="width: 2%"> - </span>
          <cargo-date-time-picker
            v-model="syncCodePartnerDialog.dateCreatedEnd"
            no="end"
            value-format="yyyy-MM-dd"
            type="date"
            clearable
            style="width: 100px;"
            :picker-options="{
              disabledDate: time => {
                const startDate = syncCodePartnerDialog.dateCreatedStart ? new Date(syncCodePartnerDialog.dateCreatedStart + ' 00:00:00') : null;
                if (startDate) {
                  // 基础限制：结束日期不能早于开始日期
                  if (time.getTime() < startDate.getTime()) {
                    return true
                  }
                }
                return false
              }
            }"
          />
        </div>
      </div>
      <div slot="footer" style="margin: 0 auto;width: fit-content;">
        <template v-if="syncCodePartnerDialog.step===1">
          <el-button type="primary" style="padding-left: 20px;padding-right: 20px" @click="nextStep">{{ $t('CargoMsg.Cargo_Next') }}</el-button>
        </template>
        <template v-if="syncCodePartnerDialog.step===2">
          <el-button style="padding-left: 20px;padding-right: 20px" @click="previousStep">{{ $t('Menu.Back') }}</el-button>
          <el-button type="primary" style="padding-left: 25px;padding-right: 25px" @click="doSyncCodePartner">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
        </template>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import cargoLeftRightResize from '@/components/Cargo/Common/cargoLeftRightResize'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor/index'
import * as FinanceInterfaceConstants from '@/class/cargo/model/parameters/FinanceInterfaceConstants'
import * as financeSoftwareConfigApi from '@/api/financeManage/financeSoftwareConfig'
import * as financeCodeMappingApi from '@/api/financeManage/financeCodeMapping'
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import FinanceUtil from '@/utils/FinanceUtil'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import MappingCodeSelector from '@/views/cargo/v0/FinanceManage/FinanceInterface/MappingCodeSelector'
import CashflowItemDialog from '@/views/cargo/v0/FinanceManage/FinanceInterface/CashflowItemDialog'
import { ExportUtils } from '@/class/cargo/model/utils/ExportUtils'
import URL from '@/api/urlTranslator'
import CargoDateTimePicker from '@/components/Cargo/Common/CargoDateTimePicker'
import { MAPPING_INVOICE_TITLE } from '@/class/cargo/model/parameters/FinanceInterfaceConstants'

export default {
  name: 'EncodeMapping',
  components: { cargoLeftRightResize, MappingCodeSelector, CashflowItemDialog, CargoDateTimePicker },
  props: {
    accountSet: { type: Object, default: null }
  },
  data() {
    return {
      cellSelected: false, // 是否选中行
      URL: URL,
      gridParams: {},
      gridApi: null,
      gridOptions: {
        rowSelection: 'single',
        suppressContextMenu: true,
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true,
          filter: true
        },
        pagination: false,
        // 单击显示编辑
        singleClickEdit: true,
        // 添加编辑组件
        frameworkComponents: {
          CargoAgGridCommonInputEditor
        },
        onRowClicked: (event) => { this.cellSelected = true; this.selectedItem = event.data }
      },
      // columnDefs: [],
      rowData: [],
      pageConditions: {
        pageNum: 1,
        pageSize: 500,
        total: 0
      },
      isEdit: false,
      leftGrid: {
        gridParams: {},
        gridApi: null,
        gridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true,
          defaultColDef: {
            resizable: true,
            filter: true
          },
          pagination: false,
          headerHeight: 0,
          onRowClicked: this.rowClickHandler
        },
        columnDefs: [
          {
            headerName: '',
            field: 'chineseName',
            width: 178,
            valueFormatter: params => {
              return this.$store.getters.isZh ? params.data.chineseName : params.data.englishName
            }
          }
        ],
        rowData: Array.from(FinanceInterfaceConstants.MAPPING_TYPES)
      },
      // isCashflowItem: false,
      // hasMapping: false,
      // fit: false,
      mappings: [],
      sortRP: false, // 区别收付
      txtFilter: '',
      txtFilterVisible: false,
      cbNewMapping: false,
      cbNewMappingVisible: false,
      softwareConfigList: [],
      accountingDocumentTypes: [],
      financeCodeMappings: [],
      code: 1,
      rpType: 0,
      codeType: 0,
      columnLabelFunc: null,
      selectorDialog: {
        visible: false,
        codeType: 0,
        codeMappingType: 0,
        existsMap: null,
        existsPartnerMap: null
      },
      map: new Map(),
      partnerMap: new Map(),
      cashflowItemDialog: {
        visible: false
      },
      selectedItem: null, // 表格选中项
      syncCodePartnerDialog: {
        visible: false,
        step: 1,
        customerCodeCheck: false, // 客户编码
        providerCodeCheck: false, // 供应商编码
        titleDateOperation: 1,
        titleDate: null, // 开票抬头日期
        dateCreatedStart: null, // 合作伙伴创建日期-开始时间
        dateCreatedEnd: null, // 合作伙伴创建日期-结束时间
        field: 'CN_SHORT_NAME'
      },
      partnerFields: [
        { value: 'CN_SHORT_NAME', label: this.$t('FinanceManage.PartnersCode') },
        { value: 'CMP_IDX', label: this.$t('FinanceManage.PartnersNumber') },
        { value: 'CHINESE_NAME', label: this.$t('FinanceManage.PartnersChineseName') }
      ],
      titleDateOperations: [
        { value: 1, label: this.$t('CargoMsg.Cargo_GreaterThan') },
        { value: 2, label: this.$t('CargoMsg.Cargo_LessThan') }
      ]
    }
  },
  computed: {
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    columnDefs() {
      return [
        {
          headerName: this.$t('CargoMsg.Cargo_Name'),
          field: 'baseDataValue',
          suppressMenu: true,
          width: 180,
          hide: this.isCashflowItem,
          lockVisible: true,
          editable: false,
          valueFormatter: params => {
            return this.columnLabelFunc ? this.columnLabelFunc(params.value) : params.value
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_VoucherType'),
          field: 'businessDataType',
          suppressMenu: true,
          width: 130,
          hide: !this.isCashflowItem,
          lockVisible: true,
          editable: false,
          valueFormatter: params => {
            return this.bizTypeLabelFunc(Number(params.value)) || ''
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_JournalEntryCategory'),
          field: 'entryType',
          suppressMenu: true,
          width: 130,
          hide: !this.isCashflowItem,
          lockVisible: true,
          // 是否开启编辑
          editable: false,
          valueFormatter: params => {
            return FinanceUtil.entryTypeLabelFunc(Number(params.value)) || ''
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_AccountTitleCode'),
          field: 'accountTitle',
          suppressMenu: true,
          width: 100,
          hide: !this.isCashflowItem,
          lockVisible: true,
          // 是否开启编辑
          editable: false
        }, {
          headerName: this.$t('CargoMsg.Cargo_DebitSideCreditSide'),
          field: 'codeMappingType',
          suppressMenu: true,
          width: 100,
          hide: !this.isCashflowItem,
          lockVisible: true,
          // 是否开启编辑
          editable: false,
          valueFormatter: params => {
            return this.debitCreditLabelFunc(params.data) || ''
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_Coding'),
          field: 'financeCode',
          suppressMenu: true,
          width: 120,
          // 是否开启编辑
          editable: this.isEdit,
          hide: this.isInvoiceTitle,
          // 单元格绑定编辑组件
          cellEditor: 'CargoAgGridCommonInputEditor',
          // 值变化事件
          onCellValueChanged: params => {
            this.onCellChange(params)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_ArCoding'),
          field: 'financeCode',
          suppressMenu: true,
          width: 120,
          // 是否开启编辑
          editable: this.isEdit,
          hide: !this.isInvoiceTitle,
          // 单元格绑定编辑组件
          cellEditor: 'CargoAgGridCommonInputEditor',
          // 值变化事件
          onCellValueChanged: params => {
            this.onCellChange(params)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_ApCoding'),
          field: 'accountTitle',
          suppressMenu: true,
          width: 120,
          hide: !this.isInvoiceTitle,
          lockVisible: true,
          // 是否开启编辑
          editable: this.isEdit,
          // 单元格绑定编辑组件
          cellEditor: 'CargoAgGridCommonInputEditor',
          // 值变化事件
          onCellValueChanged: params => {
            this.onCellChange(params)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_CodeType'),
          field: 'codeMappingType',
          suppressMenu: true,
          width: 100,
          hide: !this.hasMapping,
          lockVisible: true,
          // 是否开启编辑
          editable: false,
          valueFormatter: params => {
            return this.mppingTypeLabelFunc(params.value) || ''
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_CasualClientOrNot'),
          field: 'valueType1',
          suppressMenu: true,
          width: 100,
          hide: !this.fit,
          lockVisible: true,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            tag: this.isEdit ? 'el-checkbox' : 'span',
            attrs: {
              isEditCBFunc: (params) => {
                return this.isEdit
              },
              textConverter: (val) => {
                return val ? this.$t('CargoMsg.Cargo_Fit') : this.$t('CargoMsg.Cargo_NonCasualClient')
              }
            },
            valueChanged: p => {
              this.onCellChange2(p)
            }
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_InternalCode'),
          field: 'accountTitle',
          suppressMenu: true,
          width: 100,
          hide: !this.fit,
          lockVisible: true,
          // 是否开启编辑
          editable: this.isEdit && !this.isJDYXC,
          // 单元格绑定编辑组件
          cellEditor: 'CargoAgGridCommonInputEditor',
          // 值变化事件
          onCellValueChanged: params => {
            this.onCellChange(params)
          }
        }
      ]
    },
    // 是否现金流量项目
    isCashflowItem() {
      // CARGO-8501，增加现金流量项目核算
      return this.code === FinanceInterfaceConstants.MAPPING_CASHFLOW_ITEM.code
    },
    hasMapping() {
      return this.mappings.length > 0
    },
    // 是否散客
    fit() {
      return this.code === FinanceInterfaceConstants.MAPPING_PARTNER.code
    },
    // 是否应收开票抬头
    isInvoiceTitle() {
      return this.code === FinanceInterfaceConstants.MAPPING_INVOICE_TITLE.code
    },
    // 是否职员
    isSales() {
      return this.code === FinanceInterfaceConstants.MAPPING_SALES.code
    },
    // 是否部门
    isDept() {
      return this.code === FinanceInterfaceConstants.MAPPING_DEPARTMENT.code
    },
    // 是否合作伙伴
    isPartner() {
      return this.code === FinanceInterfaceConstants.MAPPING_PARTNER.code
    },
    // 当前版本是否金蝶云星辰
    isJDYXC() {
      return this.accountSet && this.accountSet.softwareVersions === 'JDYXC'
    },
    // 当前版本是否金蝶云星辰
    isYYTCLOUD() {
      return this.accountSet && this.accountSet.softwareVersions === 'YYTCLOUD'
    },
    // 当前版本是否金蝶云星空
    isJDYXK() {
      return this.accountSet && this.accountSet.softwareVersions === 'JDYXK'
    },
    // 是否显示 更新客商资料
    showUpdateCustomerInfo() {
      return (this.isYYTCLOUD || this.isJDYXK) && (this.isInvoiceTitle || this.isPartner)
    }
  },
  watch: {
    // isCashflowItem(newVal) {
    //   this.gridOptions.columnApi.setColumnVisible('businessDataType', newVal)
    //   this.gridOptions.columnApi.setColumnVisible('entryType', newVal)
    //   this.setColumnVisible('accountTitle', newVal, this.$t('CargoMsg.Cargo_AccountTitleCode'))
    //   this.setColumnVisible('codeMappingType', newVal, this.$t('CargoMsg.Cargo_DebitSideCreditSide'))
    //   this.gridOptions.columnApi.setColumnVisible('baseDataValue', !newVal)
    // },
    // hasMapping(newVal) {
    //   this.setColumnVisible('codeMappingType', newVal, this.$t('CargoMsg.Cargo_CodeType'))
    // },
    // fit(newVal) {
    //   this.gridOptions.columnApi.setColumnVisible('valueType1', newVal)
    //   this.gridOptions.columnApi.setColumnVisible('accountTitle', newVal)
    // }
  },
  async created() {
    this.softwareConfigList = await financeSoftwareConfigApi.queryAll().then(resp => resp.data)
    this.accountingDocumentTypes = this.accountSet.accountingDocumentType // await accountingDocumentTypeApi.query({ accountingSetKey: this.accountSet.uuid }).then(resp => resp.data.list)
    this.loadList()
  },
  methods: {
    rowClickHandler(params) {
      this.code = params.data.code
      this.loadList()
    },
    loadList() {
      // this.fit = this.code === FinanceInterfaceConstants.MAPPING_PARTNER.code
      // CARGO-8501，增加现金流量项目核算
      // this.isCashflowItem = this.code === FinanceInterfaceConstants.MAPPING_CASHFLOW_ITEM.code
      this.checkConfigMapping()
      this.queryCodeMapping()
      this.refreshDataSource()
      this.refreshLabelFunc()
      this.gridOptions.api.clearFocusedCell()
      this.cellSelected = false
      this.selectedItem = null
      //
      this.isEdit = false
      this.$nextTick(() => {
        this.gridOptions.api.setColumnDefs(this.getColumnDefs())
        this.gridOptions.api.redrawRows()
      })
    },
    saveHandler() {
      const saveList = []
      for (const rule of this.rowData) {
        if (['add', 'edit'].includes(rule.waitDealStatus)) {
          saveList.push(rule)
        }
      }
      if (saveList.length) {
        if (!this.validate(saveList)) return
        for (const mapping of saveList) {
          if (!mapping.uuid) {
            mapping.accountSetUuid = this.accountSet.uuid
            if (this.hasMapping) {
              mapping.codeMappingType = this.codeType
            } else if (this.sortRP) {
              mapping.codeMappingType = this.rpType
            } else if (this.isCashflowItem) {
              mapping.codeMappingType // 借/贷方
            } else {
              mapping.codeMappingType = 0
            }
          }
        }
        // 保存
        const loading = getLoading()
        financeCodeMappingApi.save(saveList).then(resp => {
          this.saveSuccess(resp)
          this.$message.success(this.$t('CargoMsg.Cargo_SaveSucceed'))
          this.isEdit = false
          this.$nextTick(() => {
            this.gridOptions.api.setColumnDefs(this.getColumnDefs())
            this.gridOptions.api.redrawRows()
          })
        }).finally(() => loading.close())
      } else {
        this.$message.warning(this.$t('CargoMsg.Cargo_NoDataModifiedNoNeedToSave'))
      }
    },
    cancelHandler() {
      this.isEdit = false
      this.loadList()
    },
    queryCodeMapping() {
      const params = {}
      params['cbNewMapping'] = this.cbNewMapping
      params['pageSize'] = this.pageConditions.pageSize // 当前页数量
      params['pageNum'] = this.pageConditions.pageNum // 当前页
      params['codeType'] = this.hasMapping ? this.codeType : -1
      params['rpType'] = this.sortRP ? this.rpType : -1
      params['code'] = this.code
      params['accountingSetKey'] = this.accountSet.uuid
      params['txtFilter'] = this.txtFilter
      const loading = getLoading()
      financeCodeMappingApi.query(params).then(resp => {
        this.successHandler(resp)
      }).finally(() => loading.close())
      this.gridOptions.api.clearFocusedCell()
      this.cellSelected = false
      this.selectedItem = null
    },
    successHandler(resp) {
      if (resp.data) {
        const data = resp.data
        // this.pageConditions.pageSize = data.pageSize
        this.pageConditions.pageNum = data.pageNum
        this.pageConditions.total = Number(data.total)
        this.rowData = data.list
        for (const mapping of this.rowData) {
          this.addToMap(mapping)
        }
        this.gridOptions.api.refreshCells({ force: true })
      }
    },
    addHandler() {
      if (!this.code) {
        return
      }
      if (this.isCashflowItem) {
        this.cashflowItemDialog.visible = true
        return
      }
      // 处理点击新增时， 列表中数据不匹配供应商或客户情况
      this.refreshPartnerMap()
      this.selectorDialog.codeType = this.code
      this.selectorDialog.codeMappingType = this.hasMapping ? Number(this.codeType) : 0
      this.selectorDialog.existsMap = this.map
      this.selectorDialog.existsPartnerMap = this.partnerMap
      this.selectorDialog.visible = true
    },
    editHandler() {
      if (this.rowData && this.rowData.length > 0) {
        this.isEdit = true
        this.$nextTick(() => {
          this.gridOptions.api.setColumnDefs(this.getColumnDefs())
          this.gridOptions.api.redrawRows()
        })
      }
    },
    async removeHandler() {
      const cell = this.gridOptions.api.getFocusedCell()
      // const currentRow = cell ? this.rowData[cell.rowIndex] : null
      const currentRow = cell ? this.selectedItem : null
      if (!currentRow) {
        this.$message.error(this.$t('common.tips.hasOneAtleast'))
        return
      }
      await this.$confirm(this.$t('CargoMsg.Cargo_SureToDeleteTheMapping'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        canCloseModule: true
      })
      const loading = getLoading()
      await financeCodeMappingApi.remove({ uuid: currentRow.uuid }).then(() => {
        this.removeSuccess(currentRow.uuid)
      }).finally(() => loading.close())
    },
    checkConfigMapping() {
      this.mappings = this.getSoftwareMapping(this.accountSet.softwareVersions, this.code)
      this.sortRP = (this.code === FinanceInterfaceConstants.MAPPING_SE.code || this.code === FinanceInterfaceConstants.MAPPING_SI.code || this.code === FinanceInterfaceConstants.MAPPING_AE.code || this.code === FinanceInterfaceConstants.MAPPING_AI.code)
      // this.hasMapping = this.mappings.length > 0
      if (this.hasMapping) {
        this.codeType = this.mappings[0].value
        this.refreshDataSource()
      }
    },
    getSoftwareMapping(softwareCode, mappingType) {
      const software = this.softwareConfigList.find(software => software.code === softwareCode)
      if (software && software.mappings) {
        const mappings = JSON.parse(software.mappings)
        if (mappings && mappings.length > 0) {
          for (const mapping of mappings) {
            if (Number(mapping.type) === Number(mappingType)) {
              return mapping.configs
            }
          }
        }
      }
      return []
    },
    async refreshDataSource() {
      const size = this.pageConditions.pageSize // 当前页数量
      const currentPage = (this.pageConditions.pageNum === 0) ? 1 : this.pageConditions.pageNum // 当前页
      const codeType = this.hasMapping ? this.codeType : -1
      const rpType = this.sortRP ? this.rpType : -1
      this.rowData = []
      this.map = new Map()
      this.partnerMap = new Map()
      const list = []
      if (!this.financeCodeMappings || this.financeCodeMappings.length === 0) {
        this.financeCodeMappings = await financeCodeMappingApi.query({ accountingSetKey: this.accountSet.uuid, pageSize: 10000 }).then(resp => resp.data.list)
      }
      for (const mapping of this.financeCodeMappings) {
        if (mapping.baseDataType === this.code) {
          if (this.hasMapping && codeType === mapping.codeMappingType || this.sortRP && rpType === mapping.codeMappingType || !this.hasMapping && !this.sortRP) {
            list.push(mapping)
            this.addToMap(mapping)
          }
          this.addToPartnerMap(mapping)
        }
      }
      // this.pageConditions.total = list.length // 总数量
      const nPage = size * currentPage
      const lPage = size * (currentPage - 1)
      if (list.length > 0) {
        for (let i; i <= list.length - 1; i++) {
          if (i < nPage && i >= lPage) {
            this.rowData.push(list[i])
          }
        }
      }
    },
    refreshLabelFunc() {
      this.txtFilter = ''
      this.txtFilterVisible = false
      this.cbNewMapping = false
      this.cbNewMappingVisible = false
      switch (this.code) {
        case FinanceInterfaceConstants.MAPPING_PARTNER.code:
        case FinanceInterfaceConstants.MAPPING_INTERNAL.code:
          this.columnLabelFunc = this.companyLabelFunc
          this.txtFilterVisible = true
          this.cbNewMappingVisible = true
          break
        case FinanceInterfaceConstants.MAPPING_SALES.code:
        case FinanceInterfaceConstants.MAPPING_STAFF.code:
          this.columnLabelFunc = this.userLabelFunc
          this.txtFilterVisible = true
          this.cbNewMappingVisible = true
          break
        case FinanceInterfaceConstants.MAPPING_CURRENCY.code:
          this.columnLabelFunc = null
          break
        case FinanceInterfaceConstants.MAPPING_DEPARTMENT.code:
          this.columnLabelFunc = this.departmentLabelFunc2
          break
        case FinanceInterfaceConstants.MAPPING_PREFIX.code:
          this.columnLabelFunc = this.prefixLabelFunc
          break
        case FinanceInterfaceConstants.MAPPING_ACCOUNTING_ENTRY.code:
          this.columnLabelFunc = FinanceUtil.entryTypeLabelFunc
          break
        case FinanceInterfaceConstants.MAPPING_SE.code :
        case FinanceInterfaceConstants.MAPPING_SI.code :
        case FinanceInterfaceConstants.MAPPING_AE.code :
        case FinanceInterfaceConstants.MAPPING_AI.code :
          this.columnLabelFunc = FinanceUtil.companyPropertyLabelFunc
          break
        case FinanceInterfaceConstants.MAPPING_BUSINESS_TYPE.code :
          this.columnLabelFunc = ColumnUtils.fbaJobBussStateLabelFunc
          break
        case FinanceInterfaceConstants.MAPPING_INVOICE_TITLE.code:
          this.txtFilterVisible = true
          this.columnLabelFunc = null
          break
        case FinanceInterfaceConstants.MAPPING_RECEIPT_OR_PAYMENT.code:
          this.columnLabelFunc = ColumnUtils.receiptPaymentTypeLabelFunc
          break
        default:
          break
      }
    },
    addToMap(mapping) {
      this.map.set(this.code + '-' + mapping.baseDataValue, mapping)
    },
    addToPartnerMap(mapping) {
      this.partnerMap.set(this.code + '-' + mapping.codeMappingType + '-' + mapping.baseDataValue, mapping)
    },
    refreshPartnerMap() {
      this.partnerMap = new Map()
      for (const mapping of this.financeCodeMappings) {
        if (mapping.baseDataType === this.code) {
          this.addToPartnerMap(mapping)
        }
      }
    },
    prefixLabelFunc(value) {
      for (const type of this.accountingDocumentTypes) {
        if (type.code === value) {
          return type.name
        }
      }
      return ''
    },
    userLabelFunc(value) {
      return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(value), 'chineseName')
    },
    departmentLabelFunc2(value) {
      return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department_All, 'departmentId', Number(value), 'chineseName')
    },
    companyLabelFunc(value) {
      return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(value), 'chineseName')
    },
    // 凭证类型
    bizTypeLabelFunc(value) {
      const state = CommonState.getStateByCode(FinanceInterfaceConstants.BIZ_DATA_TYPES, Number(value))
      return state == null ? '' : state.chineseName
    },
    // 借/贷方
    debitCreditLabelFunc(item) {
      return item.codeMappingType === 0 ? this.$t('CargoMsg.Cargo_DebitSide') : this.$t('CargoMsg.Cargo_CreditSide')
    },
    mppingTypeLabelFunc(value) {
      let name = ''
      for (const mapping of this.mappings) {
        if (Number(mapping.value) === Number(value)) {
          name = mapping.name
          break
        }
      }
      return name
    },
    // 处理重复field的动态显示
    setColumnVisible(field, visible, headerName) {
      const columns = this.gridOptions.columnApi.getAllColumns()
      const column = columns.find(column => column.colDef.field === field && column.colDef.headerName === headerName)
      if (column) {
        column.setVisible(visible)
      }
    },
    onCellChange(params) {
      const { node } = params
      if (node.data.uuid) {
        node.data.waitDealStatus = 'edit'
      }
    },
    // 勾选
    onCellChange2(params) {
      if (params.field === 'valueType1') {
        params.data.valueType1 = params.value
        if (params.data.uuid) {
          params.data.waitDealStatus = 'edit'
        }
      }
    },
    removeSuccess(uuid) {
      let index = this.rowData.findIndex(params => params.uuid === uuid)
      if (index > -1) {
        this.rowData.splice(index, 1)
        this.gridOptions.api.refreshCells({ force: true })
      }
      index = this.financeCodeMappings.findIndex(params => params.uuid === uuid)
      if (index > -1) this.financeCodeMappings.splice(index, 1)
      this.$message.success(this.$t('Message.DeleteSuccessfully'))
    },
    enterHandler(list) {
      list.forEach(row => { row.waitDealStatus = 'add' })
      // 添加到数组头部
      this.rowData.unshift(...list)
      this.gridOptions.api.refreshCells({ force: true })
      for (const mapping of list) {
        this.addToMap(mapping)
        this.addToPartnerMap(mapping)
      }
      this.isEdit = true
      this.$nextTick(() => {
        this.gridOptions.api.setColumnDefs(this.getColumnDefs())
        this.gridOptions.api.redrawRows()
      })
    },
    // 验证
    validate(list) {
      for (const mapping of list) {
        if (!this.isInvoiceTitle && !mapping.uuid && mapping.waitDealStatus && (!mapping.financeCode || mapping.financeCode.trim().length === 0)) {
          this.$message.warning(this.$t('CargoMsg.Cargo_PleaseEnterFinancialCode'))
          return false
        }
        if (this.isInvoiceTitle && mapping.waitDealStatus && ((!mapping.financeCode || mapping.financeCode.trim().length === 0) && (!mapping.accountTitle || mapping.accountTitle.trim().length === 0))) {
          this.$message.warning(this.$t('CargoMsg.Cargo_ApAndArCodeIsEmpty'))
          return false
        }
      }
      return true
    },
    saveSuccess(resp) {
      // 返回的列表中可能同时含有编辑的和新增的数据
      const list = resp.data
      if (!list || list.length === 0) return
      // 1 遍历rowData列表能匹配到uuid的数据（编辑的数据），更新数据
      for (let i = 0; i < this.rowData.length; i++) {
        const row = this.rowData[i]
        if (row.uuid) {
          const index = list.findIndex(params => params.uuid === row.uuid)
          if (index > -1) {
            Object.assign(row, list[index])
            list.splice(index, 1)
          }
          row.waitDealStatus = ''
        }
      }
      // 2 遍历rowData列表中没有uuid的数据 删除该数据
      for (let i = this.rowData.length - 1; i >= 0; i--) {
        if (!this.rowData[i].uuid) {
          this.rowData.splice(i, 1)
        }
      }
      // 3 添加列表里没有匹配uuid的数据（新增的数据）到列表
      this.rowData.push(...list)
      this.gridOptions.api.refreshCells({ force: true })
      this.financeCodeMappings.push(...list)
    },
    enterCashflowItemHandler(mapping) {
      mapping.baseDataType = this.code
      mapping.baseDataValue = 'CashflowItem' // 默认，导出时有非空过滤
      mapping.waitDealStatus = 'add'
      this.rowData.unshift(mapping)
      this.isEdit = true
      this.$nextTick(() => {
        this.gridOptions.api.setColumnDefs(this.getColumnDefs())
        this.gridOptions.api.redrawRows()
      })
      this.gridOptions.api.refreshCells({ force: true })
      this.cashflowItemDialog.visible = false
    },
    syncFinanceCode() {
      this.syncCodePartnerDialog.step = 1
      this.syncCodePartnerDialog.customerCodeCheck = false
      this.syncCodePartnerDialog.providerCodeCheck = false
      this.syncCodePartnerDialog.field = 'CN_SHORT_NAME'
      this.syncCodePartnerDialog.dateCreatedStart = null
      this.syncCodePartnerDialog.dateCreatedEnd = null
      this.syncCodePartnerDialog.titleDateOperation = 1
      this.syncCodePartnerDialog.titleDate = null
      this.syncCodePartnerDialog.visible = true
    },
    previousStep() {
      this.syncCodePartnerDialog.step -= 1
    },
    nextStep() {
      if (!this.syncCodePartnerDialog.customerCodeCheck && !this.syncCodePartnerDialog.providerCodeCheck) {
        this.$message.warning(this.$t('FinanceManage.AtLeastOneCustomerAndSupplierCode'))
        return
      }
      this.syncCodePartnerDialog.step += 1
    },
    doSyncCodePartner() {
      const dialog = this.syncCodePartnerDialog
      const partnerField = this.partnerFields.find(p => p.value === dialog.field)
      let confirmMsg = ''
      if (dialog.customerCodeCheck && dialog.providerCodeCheck) {
        confirmMsg = this.$t('FinanceManage.ImportCustomerAndProviderCode', [partnerField.label])
      } else if (dialog.customerCodeCheck) {
        confirmMsg = this.$t('FinanceManage.ImportCustomerCode', [partnerField.label])
      } else {
        confirmMsg = this.$t('FinanceManage.ImportProviderCode', [partnerField.label])
      }
      this.$confirm(confirmMsg, this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        dialog.visible = false
        const loading = getLoading4Cxt(this)
        const dateCreatedStart = dialog.dateCreatedStart ? dialog.dateCreatedStart + ' 00:00:00' : ''
        const dateCreatedEnd = dialog.dateCreatedEnd ? dialog.dateCreatedEnd + ' 23:59:59' : ''

        if (this.isInvoiceTitle) {
          financeCodeMappingApi.titleSyncPartnerToFinanceCode({
            accountingSetKey: this.accountSet.uuid,
            branchId: this.accountSet.branchId,
            customerCodeCheck: dialog.customerCodeCheck,
            providerCodeCheck: dialog.providerCodeCheck,
            partnerField: dialog.field,
            titleDateOperation: dialog.titleDateOperation,
            titleDate: dialog.titleDate
          }).then(res => {
            this.$message({
              iconClass: ' ',
              customClass: 'el-message-orange',
              dangerouslyUseHTMLString: true,
              message: this.$t('FinanceManage.ImportCodePenddingTip')
            })
          }).finally(() => {
            loading.close()
          })
        } else {
          financeCodeMappingApi.syncPartnerToFinanceCode({
            accountingSetKey: this.accountSet.uuid,
            branchId: this.accountSet.branchId,
            customerCodeCheck: dialog.customerCodeCheck,
            providerCodeCheck: dialog.providerCodeCheck,
            partnerField: dialog.field,
            dateCreatedStart: dateCreatedStart,
            dateCreatedEnd: dateCreatedEnd
          }).then(res => {
            this.$message({
              iconClass: ' ',
              customClass: 'el-message-orange',
              dangerouslyUseHTMLString: true,
              message: this.$t('FinanceManage.ImportCodePenddingTip')
            })
          }).finally(() => {
            loading.close()
          })
        }
      }).catch(() => { })
    },
    syncFinanceCodeHandler() {
      const loading = getLoading('app-main-content')
      const params = {}
      params.codeMappingType = this.hasMapping ? 1 : 0
      params.cmpIdx = 0
      financeCodeMappingApi.syncPartnerCode2FinanceCode(params).then(resp => {
        this.$message.success(this.$t('CargoMsg.Cargo_SyncFinanceCodeSuccess'))
        this.queryCodeMapping()
      }).finally(() => loading.close())
    },
    downloadExcelHandler() {
      ExportUtils.downloadTemplateFile('ImportEnCode.xls', 'enCode')
    },
    onImportSucceeded(response, file, fileList) {
      this.loading.close()
      if (response && response.data) {
        this.$confirm(response.data, this.$t('Message.Prompt'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
          showCancelButton: false,
          showClose: false,
          closeOnClickModal: false,
          closeOnPressEscape: false,
          dangerouslyUseHTMLString: true,
          type: response.data.toString().indexOf('导入成功') === -1 ? 'warning' : 'success'
        }).then(() => {
          this.loadList()
        }).catch(() => {})
      }
    },
    handleBeforeUpload(file) {
      this.loading = getLoading()
    },
    handleError(err) {
      this.loading.close()
      console.log(err)
    },
    getColumnDefs() {
      return [
        {
          headerName: this.$t('CargoMsg.Cargo_Name'),
          field: 'baseDataValue',
          suppressMenu: true,
          width: 180,
          hide: this.isCashflowItem,
          lockVisible: true,
          editable: false,
          valueFormatter: params => {
            return this.columnLabelFunc ? this.columnLabelFunc(params.value) : params.value
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_VoucherType'),
          field: 'businessDataType',
          suppressMenu: true,
          width: 130,
          hide: !this.isCashflowItem,
          lockVisible: true,
          editable: false,
          valueFormatter: params => {
            return this.bizTypeLabelFunc(Number(params.value)) || ''
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_JournalEntryCategory'),
          field: 'entryType',
          suppressMenu: true,
          width: 130,
          hide: !this.isCashflowItem,
          lockVisible: true,
          // 是否开启编辑
          editable: false,
          valueFormatter: params => {
            return FinanceUtil.entryTypeLabelFunc(Number(params.value)) || ''
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_AccountTitleCode'),
          field: 'accountTitle',
          suppressMenu: true,
          width: 100,
          hide: !this.isCashflowItem,
          lockVisible: true,
          // 是否开启编辑
          editable: false
        }, {
          headerName: this.$t('CargoMsg.Cargo_DebitSideCreditSide'),
          field: 'codeMappingType',
          suppressMenu: true,
          width: 100,
          hide: !this.isCashflowItem,
          lockVisible: true,
          // 是否开启编辑
          editable: false,
          valueFormatter: params => {
            return this.debitCreditLabelFunc(params.data) || ''
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_Coding'),
          field: 'financeCode',
          suppressMenu: true,
          width: 120,
          // 是否开启编辑
          editable: this.isEdit,
          hide: this.isInvoiceTitle,
          // 单元格绑定编辑组件
          cellEditor: 'CargoAgGridCommonInputEditor',
          // 值变化事件
          onCellValueChanged: params => {
            this.onCellChange(params)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_ArCoding'),
          field: 'financeCode',
          suppressMenu: true,
          width: 120,
          // 是否开启编辑
          editable: this.isEdit,
          hide: !this.isInvoiceTitle,
          // 单元格绑定编辑组件
          cellEditor: 'CargoAgGridCommonInputEditor',
          // 值变化事件
          onCellValueChanged: params => {
            this.onCellChange(params)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_ApCoding'),
          field: 'accountTitle',
          suppressMenu: true,
          width: 120,
          hide: !this.isInvoiceTitle,
          lockVisible: true,
          // 是否开启编辑
          editable: this.isEdit,
          // 单元格绑定编辑组件
          cellEditor: 'CargoAgGridCommonInputEditor',
          // 值变化事件
          onCellValueChanged: params => {
            this.onCellChange(params)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_CodeType'),
          field: 'codeMappingType',
          suppressMenu: true,
          width: 100,
          hide: !this.hasMapping,
          lockVisible: true,
          // 是否开启编辑
          editable: false,
          valueFormatter: params => {
            return this.mppingTypeLabelFunc(params.value) || ''
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_CasualClientOrNot'),
          field: 'valueType1',
          suppressMenu: true,
          width: 100,
          hide: !this.fit,
          lockVisible: true,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            tag: this.isEdit ? 'el-checkbox' : 'span',
            attrs: {
              isEditCBFunc: (params) => {
                return this.isEdit
              },
              textConverter: (val) => {
                return val ? this.$t('CargoMsg.Cargo_Fit') : this.$t('CargoMsg.Cargo_NonCasualClient')
              }
            },
            valueChanged: p => {
              this.onCellChange2(p)
            }
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_InternalCode'),
          field: 'accountTitle',
          suppressMenu: true,
          width: 100,
          hide: !this.fit,
          lockVisible: true,
          // 是否开启编辑
          editable: this.isEdit && !this.isJDYXC,
          // 单元格绑定编辑组件
          cellEditor: 'CargoAgGridCommonInputEditor',
          // 值变化事件
          onCellValueChanged: params => {
            this.onCellChange(params)
          }
        }
      ]
    },
    downloadExcelTitleHandler() {
      ExportUtils.downloadTemplateFile('ImportTitleCode.xls', 'enCode')
    },
    // 获取金蝶ID
    getKingdeId() {
      if ((!this.isSales && !this.isPartner) || !this.isJDYXC) return
      if (!this.rowData || this.rowData.length <= 0) return
      // 存合作伙伴的cmpIdx 或者 职员的 userId
      const idList = []
      for (const curRow of this.rowData) {
        if ((!curRow.financeCode || !curRow.accountTitle) && !idList.includes(curRow.baseDataValue)) {
          idList.push(curRow.baseDataValue)
        }
      }
      if (idList.length <= 0) return
      const params = {}
      params.idList = idList // 已选择的用户id或者合作伙伴的id
      params.uuid = this.accountSet.uuid
      params.code = this.code
      params.codeType = this.hasMapping ? this.codeType : -1
      const loading = getLoading('app-main-content')
      financeCodeMappingApi.getKingdeId(params).then(res => {
        const result = res.data
        if (result) {
          let isSync = false // 是否同步过
          for (const row of this.rowData) {
            const curData = result[row.baseDataValue]
            if (!curData) continue
            row.financeCode = curData.number
            row.accountTitle = curData.id
            row.waitDealStatus = row.uuid ? 'edit' : 'add'
            if (!isSync) isSync = true
          }
          if (isSync) {
            this.$message.success(this.$t('Message.SynchronizationSucceeded'))
            this.gridOptions.api.refreshCells({ force: true })
          } else {
            this.$message.warning(this.$t('Message.KingdeeNotExist'))
          }
          return
        }
        this.$message.error(this.$t('Message.SynchronizationFail'))
      }).finally(() => loading.close())
    },
    /**
     * 更新客商资料
     */
    updateCustomerInfo() {
      if (!this.showUpdateCustomerInfo) return
      if (!this.check()) return
      const params = {}
      params.branchId = this.accountSet.branchId
      params.accountingSetKey = this.accountSet.uuid
      params.code = this.code
      params.codeType = this.hasMapping ? this.codeType : -1
      const loading = getLoading('app-main-content')
      financeCodeMappingApi.updateCustomerInfo(params).then(res => {
        const result = res.data
        if (result && result.success) {
          this.queryCodeMapping()
          this.$message.success(this.$t('CargoMsg.Cargo_Synchronizing'))
        } else {
          this.$message.error(this.$t('Message.SynchronizationFail'))
        }
      }).finally(() => loading.close())
    },
    check() {
      if (this.isJDYXK && !this.accountSet.accountingOrganization) {
        this.$message.warning(this.$t('CargoMsg.Cargo_AccountingOrganizationCode') + this.$t('CargoMsg.Cargo_CanNotEmpty'))
        return false
      }
      return true
    }
  }
}
</script>

<style scoped lang="scss">
.grid-view::v-deep .sync-code-partner-dialog {
  .el-step {
    .el-step__line {
      background: transparent;
      border: 1px dashed #DCDFE6;
    }
  }
  .step1 {
    .el-step {
      .icon-solid-circle-origin {
        width: 16px;
        height: 16px;
        border-radius: 50%;
        background: #BBBBBB;
      }
      .el-step__title {
        &.is-process {
          font-size: 12px;
          color: #909399;
        }
        &.is-finish {
          font-size: 12px;
          color: #1F75D5;
        }
      }
    }
  }
  .step2 {
    .el-step {
      .el-step__title {
        &.is-success {
          font-size: 12px;
          color: #909399;
        }
        &.is-process {
          font-size: 12px;
          color: #1F75D5;
        }
      }
      .is-process .el-step__icon {
        color: #1F75D5;
        border-color: #1F75D5;;
      }
    }
  }
  .el-checkbox {
    .el-checkbox__label {
      font-size: 14px !important;
    }
  }
}
</style>
